var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.onClickAway,
          expression: "onClickAway"
        }
      ],
      ref: "dropdown",
      class: { "dropdown-wrap": true, "has-focus": _vm.componentHasFocus },
      on: { click: _vm.handleComponentClick }
    },
    [
      _c("text-field", {
        ref: "textInput",
        staticClass: "text-input",
        attrs: {
          disabled: true,
          label: _vm.label,
          "leading-icon": _vm.leadingIcon,
          "trailing-icon": "arrow_drop_down",
          type: "text",
          valid: _vm.valid,
          value: _vm.inputVal,
          filled: ""
        },
        on: {
          "update:valid": function($event) {
            _vm.valid = $event
          },
          "update:value": function($event) {
            _vm.inputVal = $event
          },
          click: _vm.handleComponentClick
        }
      }),
      _vm._v(" "),
      _vm.helper
        ? _c(
            "m-text-field-helper-text",
            {
              attrs: {
                "validation-msg": _vm.validationMsg,
                persistent: _vm.persistent
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.helper) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.componentHasFocus
        ? _c(
            "m-elevation",
            { staticClass: "dropdown", attrs: { transition: "", level: 8 } },
            [
              _vm.componentHasFocus
                ? _c(
                    "ul",
                    { staticClass: "list-items" },
                    _vm._l(_vm.options, function(option) {
                      return _c(
                        "m-list-item",
                        {
                          key: option,
                          staticClass: "dropdown-option",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.handlePrimarySelect(option)
                            }
                          }
                        },
                        [_vm._v("\n        " + _vm._s(option) + "\n      ")]
                      )
                    }),
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }